// components/howItWorks/howItWorks.tsx
import React from "react";
import styles from "./howItWorks.module.scss";
import Link from "next/link";
import useLocale from "hooks/useLocale";

type Item = {
  k: string;
  title: string;
  desc: string;
};

const dict: Record<
  string,
  { heading: string; sub: string; items: Item[]; cta1: string; cta2: string }
> = {
  it: {
    heading: "Il Futuro è vicino a te.",
    sub: "Tre passi semplici per iniziare su Gloco.",
    items: [
      {
        k: "discover",
        title: "Scopri i negozi locali",
        desc: "Trova prodotti e attività nella tua zona, come in un centro commerciale digitale locale.",
      },
      {
        k: "buy",
        title: "Acquista in modo semplice",
        desc: "Ordina online in pochi click. Scegli ritiro in negozio oppure consegna a domicilio.",
      },
      {
        k: "support",
        title: "Sostieni la tua comunità",
        desc: "Ogni acquisto aiuta l’economia locale e valorizza le eccellenze del territorio.",
      },
    ],
    cta1: "Vai al Marketplace",
    cta2: "Completa il tuo profilo",
  },
  en: {
    heading: "How it works",
    sub: "Three simple steps to get started with Gloco.",
    items: [
      {
        k: "discover",
        title: "Discover nearby shops",
        desc: "Find products and businesses around you, like a digital local mall.",
      },
      {
        k: "buy",
        title: "Buy the simple way",
        desc: "Order in a few clicks. Choose in-store pickup or home delivery.",
      },
      {
        k: "support",
        title: "Support your community",
        desc: "Every purchase helps local economy and celebrates local excellence.",
      },
    ],
    cta1: "Go to Marketplace",
    cta2: "Complete your profile",
  },
};

export default function HowItWorks() {
  const { locale } = useLocale();
  const t = dict[locale] ?? dict.it;

  // 👉 funzione che apre il modale "Accedi" e poi clicca "Registrati"
  const openRegisterModal = () => {
    // 1️⃣ prova a cliccare il bottone "Accedi" dell'header
    const loginBtn =
      Array.from(document.querySelectorAll("button")).find(
        (el) => el.textContent?.trim().toLowerCase() === "accedi"
      ) ||
      (document.querySelector('button[class*="header_login"]') as HTMLElement | null);

    (loginBtn as HTMLElement)?.click();

    // 2️⃣ dopo un piccolo ritardo, clicca il tab/link "Registrati" nel modale
    let tries = 0;
    const interval = setInterval(() => {
      tries++;
      const registerEl = Array.from(
        document.querySelectorAll('button, a, [role="button"]')
      ).find((el) => el.textContent?.trim().toLowerCase() === "registrati");
      if (registerEl) {
        (registerEl as HTMLElement).click();
        clearInterval(interval);
      }
      if (tries > 10) clearInterval(interval); // smette dopo ~1s
    }, 100);
  };

  return (
    <section className={styles.howitworks}>
      <div className={styles.howitworks__wrap}>
        <header className={styles.howitworks__head}>
          <h2>{t.heading}</h2>
          <p className={styles.howitworks__sub}>{t.sub}</p>
        </header>

        <div className={styles.howitworks__grid}>
          {t.items.map((it) => (
            <div key={it.k} className={styles.howitworks__card}>
              <div className={styles.howitworks__num} aria-hidden>
                •
              </div>
              <h3 className={styles.howitworks__title}>{it.title}</h3>
              <p className={styles.howitworks__desc}>{it.desc}</p>
            </div>
          ))}
        </div>

        <div className={styles.howitworks__cta}>
          <Link href="/" className={`${styles.btn} ${styles["btn--primary"]}`}>
            {t.cta1}
          </Link>

          {/* 👇 secondo pulsante modificato */}
          <button
            type="button"
            className={`${styles.btn} ${styles["btn--ghost"]}`}
            onClick={(e) => {
              e.preventDefault();
              openRegisterModal();
            }}
          >
            {t.cta2}
          </button>
        </div>
      </div>
    </section>
  );
}
